import { createSlice } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const persistConfig = {
  key: "getBusinessSlice",
  version: 1,
  storage,
  blacklist: [],
};

const initialState= {
    data:[]
  };

export const getBusinessSlice = createSlice({
  name: "getbuisness",
  initialState,
  reducers: {
    
    setBuisnessData: (state, action) => {
        state.data=action.payload;
      },
     
  },
});

export const { setBuisnessData} = getBusinessSlice.actions;

export default persistReducer(persistConfig, getBusinessSlice.reducer);
